// extracted by mini-css-extract-plugin
export default {"customDragLayer":"customDragLayer--HEiQR"};